<template>
  <div class="column">
    <section v-if="showUnidade != false" class="col">
      <lista-unidades-select v-model="unidade"></lista-unidades-select>
    </section>

    <q-dialog v-model="ativar">
      <q-card style="width: 80%">
        <div class="q-gutter-md">
          <q-carousel
            v-model="slide"
            transition-prev="scale"
            transition-next="scale"
            swipeable
            animated
            control-color="white"
            navigation
            padding
            arrows
            height="300px"
            class="bg-brand-1 text-white shadow-1 rounded-borders"
          >
            <q-carousel-slide :name="0" class="column no-wrap flex-center">
              <a download :href="link">
                <q-icon name="file_download" size="56px" />
              </a>
              <div class="q-mt-md text-center">
                <div>
                  Clique no icone para baixar o modelo mais atualizado do
                  template
                </div>
              </div>
            </q-carousel-slide>
            <q-carousel-slide
              v-for="(info, index) in infos"
              :key="index"
              :name="index + 1"
              class="column no-wrap flex-center"
            >
              <q-icon :name="info.icon" size="56px" />
              <div class="q-mt-md text-center">
                {{ info.name }}
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useStore } from "vuex";
export default {
  components: { ListaUnidadesSelect },
  props: ["activeSlide", "link", "infos", "showUnidade"],
  setup(props) {
    const slide = ref(0);
    const ativar = ref(false);
    const unidade = ref();
    const store = useStore();

    watch(
      () => props.activeSlide,
      () => {
        if (props.activeSlide == false) {
          ativar.value = true;
          return;
        }

        ativar.value = props.activeSlide;
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
      }
    );

    return {
      slide,
      ativar,
      unidade,
    };
  },
};
</script>

<style></style>
